var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-price-rule-edit-list',{attrs:{"rules":_vm.contact.PriceRules,"default-price-category":_vm.contact.SellPriceCategory,"new-rule-constructor":_vm.newRuleConstructor}})
}
var staticRenderFns = []

export { render, staticRenderFns }